import { MenuCheckedValueChangeEvent, MenuItemRadio, MenuList } from "@fluentui/react-components";
import { Stack, Text, TooltipHost } from "@fluentui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { textStyles } from "@/styles/textStyles";
import { gapStyles } from "@/styles/gapStyles";
import { useNavigate } from "react-router-dom";
import { getParameter, classNames, getCurrentCustomer } from "@/utilities/common";
import styles from "./index.module.less";
import { getBasePath, getDefaultRouter, isACustomerAgency, verifyProduct } from "@/utilities/function";
import { isLeadGenAgency } from "@LeadGen/utilities/function";
import i18n from "@/i18n";

interface menuListProps {
  menuItems?: any
  menulistStyle?: any
}

const BZAMenuList = (props: menuListProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const CID: any = Number(getParameter("cid"));
  const [checkedCustomerValues, setCheckedCustomerValues] = useState<Record<string, string[]>>({ customer: [CID] });
  return (
    <MenuList
      style={props.menulistStyle}
      checkedValues={checkedCustomerValues}
      onCheckedValueChange={(e: MenuCheckedValueChangeEvent, { name, checkedItems }: any) => {
        const currentCustomerInfo = getCurrentCustomer(Number(checkedItems[0]));
        const newBasePath = getBasePath(Number(currentCustomerInfo[0]?.productType), Number(currentCustomerInfo[0]?.primaryPurpose), "leadgen_accountManagement",
          currentCustomerInfo[0]?.region.toLowerCase() === "zh-cn" ? "dashboard" : "Non_dashboard");
        const url = getDefaultRouter(currentCustomerInfo[0]?.customerType,
          !isLeadGenAgency(currentCustomerInfo[0]?.agencyType)
            ? "waitingOrder"
            : "leadgen_accountManagement", `?cid=${checkedItems[0]}`, newBasePath);
        window.localStorage.setItem("i18nextLng", currentCustomerInfo[0]?.region?.toLowerCase() === "zh-cn" ? "zh" : "en");
        i18n.changeLanguage(currentCustomerInfo[0]?.region?.toLowerCase() === "zh-cn" ? "zh" : "en");
        navigate(url);
        setCheckedCustomerValues((s) => ({ ...s, [name]: checkedItems }));
      }}
    >
      {props.menuItems.map((item: any, index: any) => {
        return (
          <TooltipHost content={item.customerName} key={index}>
            <MenuItemRadio
              name="customer"
              value={item.customerId}
              secondaryContent={
                item.customerStatus === 0
                  ? <Text className={textStyles.textDisabled}>{t("Basics.menuButton.permissionNotActivated")}</Text>
                  : item.numberOfAccounts + t("Basics.menuButton.accountsCount")
              }
              tabIndex={item.customerStatus === 0 ? -1 : 0}
              className={classNames({
                [styles.menu_item]: true,
                [styles.item_disabled]: item.customerStatus === 0
              })}
              disabled={item.customerStatus === 0}
              style={{
                borderBottom: "1px solid #edebe9",
                maxWidth: 400,
                alignItems: "center",
                padding: "8px 24px 8px 8px"
              }}
              checkmark={<div className={styles.account_check_mark} />}
            >

              <Text className={gapStyles.flexColumn}>
                <Text block
                  nowrap
                  className={classNames({
                    [textStyles.textDisabled]: item.customerStatus === 0,
                    [textStyles.textColorGray160]: item.customerStatus !== 0
                  })}
                  style={{ maxWidth: 280 }}
                >
                  {isACustomerAgency(item?.customerType) && !isLeadGenAgency(item?.agencyType)
                    ? <Stack style={{ width: "100%" }} horizontal>
                      <Text block nowrap style={{
                        wordBreak: "break-all",
                        wordWrap: "break-word",
                        maxWidth: "60%",
                        minWidth: "20%",
                      }}>
                        {item.customerName}
                      </Text>
                      <span className={textStyles.textDisabled}>{t("Basics.menuButton.billingAgency")}</span>
                    </Stack>
                    : verifyProduct(item?.productType, item?.primaryPurpose)
                      ? <Stack style={{ width: "100%" }} horizontal>
                        <Text block nowrap style={{
                          wordBreak: "break-all",
                          wordWrap: "break-word",
                          maxWidth: "80%",
                          minWidth: "20%",
                        }}>
                          {item.customerName}
                        </Text>
                        <span className={textStyles.textDisabled}>(LeadGen)</span>
                      </Stack>
                      : item.region !== "zh-cn"
                        ? <Stack style={{ width: "100%" }} horizontal>
                          <Text block nowrap style={{
                            wordBreak: "break-all",
                            wordWrap: "break-word",
                            maxWidth: "80%",
                            minWidth: "20%",
                          }}>
                            {item.customerName}
                          </Text>
                          <span className={textStyles.textDisabled}>(Markets other than ZH-CN)</span>
                        </Stack>
                        : item.customerName}
                  {/* {item.customerName} */}
                </Text>
                <Text block nowrap className={textStyles.textGray160}>
                  {item.customerNumber}
                </Text>
              </Text>

            </MenuItemRadio>
          </TooltipHost>
        );
      })}
    </MenuList>
  );
};

export default BZAMenuList;
